import LjbLogin from './LjbLogin'
import LjbLoading from './LjbLoading'

export default {
  LjbLogin,
  LjbLoading
}



// WEBPACK FOOTER //
// ./src/components/common/index.js